import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=95946538&"
import script from "./SlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "../assets/css/menu.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports